// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__9hWnr","mainDiv":"firstFold_mainDiv__myB0d","heading":"firstFold_heading__tAT_o","subParagraph":"firstFold_subParagraph__AnLe6"};